import { useState, useEffect } from "react";

const useScreenDimensions = () => {
	const getDimensions = () => ({
		width: window.screen.width,
		height: window.screen.height,
	});

	const [screenSize, setScreenSize] = useState(getDimensions);

	useEffect(() => {
		const handleResize = () => {
			setScreenSize(getDimensions());
		};

		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	return screenSize;
};

export default useScreenDimensions;
